import React, { useEffect } from 'react';
import { Box, Button, TextField, Grid, MenuItem, Typography } from '@mui/material';
import { getJobinfostatus } from '../../ApiSevices/ReportApis';
import { getbroker } from '../../ApiSevices/UserMasterApis';
import { getQcJobStatus } from '../../ApiSevices/QuoteCompareAPI';

interface ReportFilterFormProps {
    onSubmit: (filters: any) => void;
    onExport?: (filters: any) => void;
    showBroker?: boolean;
    showStatus?: boolean;
    showFromDate?: boolean;
    showToDate?: boolean;
    showGenerteBtn?: boolean;
    showExcelBtn?: boolean;
    showSubmitBtn?: boolean;
    showJobid?: boolean;
}

const ReportFilterForm: React.FC<ReportFilterFormProps> = ({ onSubmit, onExport, showBroker = true, showStatus = true, showFromDate = true, showToDate = true, showGenerteBtn = true, showExcelBtn = true, showSubmitBtn = true, showJobid = true }) => {
    const [filters, setFilters] = React.useState({ brokerName: 'All', fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split("T")[0], toDate: '', status: 'All', jobId: '' });
    const [brokers, setBrokers] = React.useState<{ Broker_ID: number; vchBrokerName: string }[]>([]);
    const [jobInfoStatus, setJobInfoStatus] = React.useState<{ Id: number; Name: string }[]>([]);
    const [brokerLoading, setBrokerLoading] = React.useState(showBroker);
    const [statusLoading, setStatusLoading] = React.useState(false);
    const [jobIdValid, setJobIdValid] = React.useState(true);

    const loading = brokerLoading || statusLoading;

    useEffect(() => {
        const fetchBrokers = async () => {
            try {
                const brokerData = await getbroker();
                setBrokers(brokerData?.sort((a: any, b: any) => a?.vchBrokerName.localeCompare(b?.vchBrokerName)) || []);
            } catch (error) {
                console.error('Error fetching brokers:', error);
            } finally {
                setBrokerLoading(false);
            }
        };

        if (showBroker) {
            setBrokerLoading(true);
            fetchBrokers();
        } else {
            setBrokerLoading(false);
        }
    }, [showBroker, showStatus]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
            ...(name === 'fromDate' && {
                toDate: ''
            })
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const submittedFilters: any = {};
        if (showFromDate) submittedFilters.fromDate = filters.fromDate;
        if (showToDate) submittedFilters.toDate = filters.toDate;
        if (showBroker) submittedFilters.brokerName = filters.brokerName;
        if (showStatus) submittedFilters.status = filters.status;
        if (showJobid) submittedFilters.jobId = filters.jobId;

        onSubmit(submittedFilters);
    };

    const handleExport = () => {
        if (onExport) {
            const exportFilters: any = {};
            if (showFromDate) exportFilters.fromDate = filters.fromDate;
            if (showToDate) exportFilters.toDate = filters.toDate;
            if (showBroker) exportFilters.brokerName = filters.brokerName;
            if (showStatus) exportFilters.status = filters.status;
            if (showJobid) exportFilters.jobId = filters.jobId;

            onExport(exportFilters);
        }
    };

    const onBrokerChangeStatus = async (e: any) => {
        if (showStatus) {
            setStatusLoading(true);
            const { name, value } = e.target;
            if (showStatus) {
                try {
                    const JobInfoStatusData = await getQcJobStatus(value);
                    setJobInfoStatus(JobInfoStatusData || []);
                } catch (error) {
                    console.error('Error fetching JobInfoStatus:', error);
                } finally {
                    setStatusLoading(false);
                }
            }
        }
    }

    const handleJobidChange = (event: any) => {
        const { name, value } = event.target;
        const jobIdPattern = /^\d{4}[a-z]{3}\d{14}\d{3}$/;

        if (name === "jobId") {
            setJobIdValid(value === "" || jobIdPattern.test(value));
        }

        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const getMinToDate = () => {
        if (!filters.fromDate) return '';
        return new Date(filters.fromDate).toISOString().split('T')[0];
    };

    const getMaxToDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const commonTextFieldSx = {
        "& .MuiOutlinedInput-root": { height: 30 },
        "& .MuiOutlinedInput-input": {
            padding: "4px 10px",
            fontSize: "0.875rem"
        }
    };

    const commonMenuItemSx = {
        height: 30,
        padding: "4px 10px",
        fontSize: "0.875rem"
    };

    let isFormValid
    if (window.location.pathname === '/misreport/autojoblobmappingreport') {
        isFormValid = true
    } else {
        isFormValid = Boolean(filters.toDate);
    }

    const isFormValidAcord = Boolean(filters.jobId);


    return (
        < >
            {loading && (
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                    zIndex: 9999
                }}>
                    <div className="loader"></div>
                </Box>
            )}
            <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
                <Grid container spacing={2}>
                    {showBroker && (
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="body2" gutterBottom>Select Broker</Typography>
                            <TextField
                                select
                                name="brokerName"
                                fullWidth
                                size="small"
                                value={filters.brokerName}
                                onChange={(e: any) => {
                                    handleChange(e);
                                    onBrokerChangeStatus(e);
                                }}
                                sx={commonTextFieldSx}
                            >
                                <MenuItem value="All" sx={commonMenuItemSx}>All</MenuItem>
                                {brokers?.map(broker => (
                                    <MenuItem
                                        key={broker?.Broker_ID}
                                        value={broker?.Broker_ID}
                                        sx={commonMenuItemSx}
                                    >
                                        {broker?.vchBrokerName}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    )}

                    {showFromDate && (
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                                Upload From Date
                            </Typography>
                            <TextField
                                name="fromDate"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                size="small"
                                value={filters.fromDate}
                                onChange={handleChange}
                                inputProps={{
                                    max: getMaxToDate()
                                }}
                                required
                                sx={commonTextFieldSx}
                            />
                        </Grid>
                    )}

                    {showToDate && (
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                                Upload To Date
                            </Typography>
                            <TextField
                                name="toDate"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                size="small"
                                value={filters.toDate}
                                onChange={handleChange}
                                inputProps={{
                                    min: getMinToDate(),
                                    max: getMaxToDate()
                                }}
                                disabled={!filters.fromDate}
                                sx={commonTextFieldSx}
                            />
                        </Grid>
                    )}

                    {showStatus && (
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                                Select Status
                            </Typography>
                            <TextField
                                select
                                name="status"
                                fullWidth
                                size="small"
                                value={filters.status}
                                onChange={handleChange}
                                sx={commonTextFieldSx}
                            >
                                <MenuItem value="All" sx={commonMenuItemSx}>All</MenuItem>
                                {jobInfoStatus?.map(jobInfo => (
                                    <MenuItem
                                        key={jobInfo?.Id}
                                        value={jobInfo?.Id}
                                        sx={commonMenuItemSx}
                                    >
                                        {jobInfo?.Name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    )}

                    {showJobid && (
                        <>
                            <Grid item xs={12} sm={8} md={6} lg={4}>
                                <TextField
                                    name="jobId"
                                    placeholder="Enter Job ID"
                                    size="small"
                                    fullWidth
                                    value={filters.jobId}
                                    onChange={handleJobidChange}
                                    error={!jobIdValid && filters.jobId !== ""}
                                    helperText={!jobIdValid && filters.jobId !== "" ? "*Invalid JobId format" : ""}
                                    sx={{
                                        backgroundColor: '#fff',
                                        "& .MuiOutlinedInput-root": { height: 30 },
                                        '& .MuiOutlinedInput-input': {
                                            padding: '4px 12px',
                                            fontSize: '14px'
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} md={2} lg={1}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    disabled={!isFormValidAcord || !jobIdValid}
                                    sx={{
                                        height: 30,
                                        fontSize: '0.75rem',
                                        textTransform: 'none',
                                        backgroundColor: '#2a327d',
                                        fontWeight: 'bold',
                                    }}
                                    onSubmit={handleSubmit}
                                >
                                    Submit
                                </Button>

                            </Grid>

                            <Grid item xs={12} sm={6} md={3} lg={2}>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    disabled={!isFormValidAcord || !jobIdValid}
                                    sx={{
                                        backgroundColor: '#5bc0de',
                                        fontSize: '0.75rem',
                                        height: 30,
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                    }}
                                    onClick={handleExport}
                                >
                                    Export as Excel
                                </Button>
                            </Grid>
                        </>
                    )}

                    {showGenerteBtn && (
                        <Grid item xs={12} sm={6} md={3} lg={2} mt={3}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                disabled={!isFormValid}
                                sx={{
                                    backgroundColor: '#2a327d',
                                    fontSize: '0.75rem',
                                    height: 30,
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                }}
                            >
                                Generate Report
                            </Button>
                        </Grid>
                    )}

                    {showExcelBtn && (
                        <Grid item xs={12} sm={6} md={3} lg={2} mt={3}>
                            <Button
                                variant="contained"
                                fullWidth
                                disabled={!isFormValid}
                                sx={{
                                    backgroundColor: '#5bc0de',
                                    fontSize: '0.75rem',
                                    height: 30,
                                    textTransform: 'none',
                                    fontWeight: 'bold',

                                }}
                                onClick={handleExport}
                            >
                                Export as Excel
                            </Button>
                        </Grid>
                    )}
                </Grid>

            </Box>
        </>

    );
};

export default ReportFilterForm;
